import OurJourney from "../components/OurJourney";
import Mission from "../components/Mission";
import PageNav from "../components/PageNav";
import { aboutData } from "../content/About";
import { teamData } from "../content/Team";
import { useEffect, useState } from "react";
import Teams from "../components/Teams";
import PageIntro from "../components/PageIntro";
import boardActionPlanPdf from "../assets/board_committee/Committee_Chart_Update.pdf";

const About = () => {
 const file = { href: "BOARD_ACTION_PLAN_PDF" };
  const sections = teamData.page[0]?.sections || [];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [announcement, setAnnouncement] = useState("");
  const currentMember = sections[currentIndex] || null;
  const [isMobileExpanded, setIsMobileExpanded] = useState(false);
 const pdfMap = {
    BOARD_ACTION_PLAN_PDF: boardActionPlanPdf,
  };
 
  useEffect(() => {
    if (!currentMember) return;
    setAnnouncement(
      `Selected: ${currentMember?.name?.trim() || ""}, ${
        currentMember?.role || ""
      }`
    );
    setIsMobileExpanded(false);
  }, [currentMember]);

  if (!currentMember) {
    return <div className="p-10 text-center">No team data found</div>;
  }

  const goToSlide = (index) => setCurrentIndex(index);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % sections.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + sections.length) % sections.length);
  };

  const getMemberImageClass = (member) =>
    member?.name?.trim() === "Anup Kumar Singh"
      ? "scale-125 -translate-y-4"
      : "";

  return (
    <>
      <PageIntro
        title="About"
        subtitle="A brief look at our journey, mission, and leadership."
        compactBottom
        contentWidthClass="max-w-[1400px]"
        bottomPadding="pb-4 md:pb-6"
      >
        <PageNav
          data={aboutData}
          allowedTitles={[
            "Journey",
            "Board of Directors",
            "Mission & Vision",
            "Leadership Team",
            "Board Committee",
          ]}
          isFlush
        />
      </PageIntro>
      <section id="journey">
        <OurJourney compactTop />
      </section>
      {/* <section id="about">
        <AboutUs data={aboutData} />
      </section> */}
      <section id="board-of-directors" className="bg-gray-100 py-12 px-4">
        <div className="max-w-7xl mx-auto bg-ofWhite rounded-[32px] p-6 sm:p-8 md:p-12 shadow-xl border-8 border-ofWhite space-y-8">
          <div className="text-center space-y-2">
            <p className="text-xs uppercase tracking-[0.4em] text-black/50">
              Board of Directors
            </p>
            <h3 className="text-2xl md:text-3xl font-semibold text-black/85">
              Experienced leadership guiding our mission with integrity and
              accountability.
            </h3>
            <p className="text-black/60 text-sm max-w-3xl mx-auto">
              Meet the leadership team guiding BSS Sonata’s people-first
              strategy across finance, risk, and community engagement.
            </p>
          </div>

          {/* Desktop / Tablet */}
          <div className="hidden md:grid grid-cols-[240px_minmax(0,1fr)_320px] gap-10 items-start">
            <div
              className="flex flex-col gap-3 max-h-[420px] overflow-y-auto pr-2"
              role="listbox"
              aria-label="Board members"
            >
              {sections.map((member, index) => {
                const isActive = index === currentIndex;
                return (
                  <button
                    key={member.name}
                    onClick={() => goToSlide(index)}
                    className={`w-full text-left flex items-center gap-3 px-4 py-3 rounded-2xl border transition-all focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1c3d72] ${
                      isActive
                        ? "border-[#1c3d72] bg-[#1c3d72]/10 shadow-sm"
                        : "border-white3 hover:border-[#1c3d72]/40"
                    }`}
                    aria-selected={isActive}
                    role="option"
                  >
                    <img
                      src={member.image}
                      alt=""
                      className="w-12 h-12 rounded-full object-cover ring-2 ring-white"
                    />
                    <p className="font-semibold text-black/85 leading-tight">
                      {member.name.trim()}
                    </p>
                  </button>
                );
              })}
            </div>

            <div className="bg-white3 rounded-[24px] p-6 shadow-inner space-y-4 min-h-[360px]">
              <div className="space-y-1">
                <p className="text-sm uppercase tracking-[0.3em] text-red/70">
                  {currentMember.role}
                </p>
                <h4 className="text-2xl font-semibold text-black">
                  {currentMember.name.trim()}
                </h4>
              </div>
              <div className="space-y-3 text-sm text-black/70 leading-relaxed">
                {(isMobileExpanded
                  ? currentMember.paragraphs
                  : currentMember.paragraphs.slice(0, 2)
                ).map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>
              {!isMobileExpanded && currentMember.paragraphs.length > 2 && (
                <button
                  onClick={() => setIsMobileExpanded(true)}
                  className="text-sm font-semibold text-[#1c3d72] underline underline-offset-2"
                >
                  Read more
                </button>
              )}
              {isMobileExpanded && currentMember.paragraphs.length > 2 && (
                <button
                  onClick={() => setIsMobileExpanded(false)}
                  className="text-sm font-semibold text-[#1c3d72] underline underline-offset-2"
                >
                  Show less
                </button>
              )}
            </div>

            <div className="bg-white rounded-[32px] shadow-[0_30px_80px_rgba(7,17,36,0.18)] overflow-hidden">
              <div className="relative w-full aspect-[3/4]">
                <img
                  src={currentMember.image}
                  alt={currentMember.name}
                  className={`w-full h-full object-cover ${getMemberImageClass(currentMember)}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 px-6 pb-6 pt-16">
                  <div className="rounded-[20px] bg-white/30 backdrop-blur-lg border border-white/40 px-5 py-3 text-center shadow-lg">
                    <p className="text-lg font-semibold text-gray-600">
                      {currentMember.name.trim()}
                    </p>
                    <p className="text-xs uppercase tracking-[0.3em] text-gray-400">
                      {currentMember.role}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Mobile */}
          <div className="md:hidden space-y-6">
            <div className="bg-white rounded-[28px] shadow-[0_20px_60px_rgba(7,17,36,0.15)] overflow-hidden">
              <div className="relative w-full aspect-[3/4]">
                <img
                  src={currentMember.image}
                  alt={currentMember.name}
                  className={`w-full h-full object-cover ${getMemberImageClass(currentMember)}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/15 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 px-5 pb-5 pt-14">
                  <div className="rounded-[18px] bg-white/35 backdrop-blur-lg border border-white/40 px-4 py-2.5 text-center shadow-md">
                    <p className="text-base font-semibold text-gray-600">
                      {currentMember.name.trim()}
                    </p>
                    <p className="text-[11px] uppercase tracking-[0.3em] text-gray-400">
                      {currentMember.role}
                    </p>
                  </div>
                </div>
              </div>
              <div className="p-5 space-y-3">
                <div className="space-y-1">
                  <p className="text-xs uppercase tracking-[0.3em] text-red/70">
                    {currentMember.role}
                  </p>
                  <h4 className="text-xl font-semibold text-black">
                    {currentMember.name.trim()}
                  </h4>
                </div>
                <div className="space-y-3 text-sm text-black/70 leading-relaxed">
                  {(isMobileExpanded
                    ? currentMember.paragraphs
                    : currentMember.paragraphs.slice(0, 2)
                  ).map((paragraph, index) => (
                    <p key={index}>{paragraph}</p>
                  ))}
                </div>
                {currentMember.paragraphs.length > 2 && (
                  <button
                    onClick={() => setIsMobileExpanded((prev) => !prev)}
                    className="text-sm font-semibold text-[#1c3d72] underline underline-offset-2"
                  >
                    {isMobileExpanded ? "Show less" : "Read more"}
                  </button>
                )}
                <div className="flex items-center justify-between pt-4">
                  <button
                    onClick={prevSlide}
                    className="px-4 py-2 rounded-full border border-[#1c3d72] text-[#1c3d72] text-xs font-semibold uppercase tracking-[0.2em]"
                  >
                    Prev
                  </button>
                  <button
                    onClick={nextSlide}
                    className="px-4 py-2 rounded-full border border-[#1c3d72] text-[#1c3d72] text-xs font-semibold uppercase tracking-[0.2em]"
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
            <div className="flex gap-3 overflow-x-auto pb-2">
              {sections.map((member, index) => {
                const isActive = index === currentIndex;
                return (
                  <button
                    key={`${member.name}-mobile`}
                    onClick={() => goToSlide(index)}
                    className={`flex-shrink-0 w-16 h-16 rounded-2xl overflow-hidden border-2 transition ${isActive ? "border-red" : "border-transparent opacity-60"}`}
                    aria-label={`View ${member.name.trim()}`}
                  >
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover"
                    />
                  </button>
                );
              })}
            </div>
          </div>
          <div className="sr-only" aria-live="polite">
            {announcement}
          </div>
        </div>
      </section>
      <section id="mission-vision">
        <Mission data={aboutData} />
      </section>
      <section className="py-16 px-6 bg-ofWhite text-center">
        <div className="max-w-3xl mx-auto space-y-3">
          <p className="text-xs uppercase tracking-[0.4em] text-black/50">
            Our People
          </p>
          <h3 className="text-3xl md:text-4xl font-semibold text-[#1c3d72]">
            The team that makes it all happen.
          </h3>
          <p className="text-black/60 text-sm md:text-base">
            Meet the leaders translating our mission and vision into meaningful
            action for communities across India.
          </p>
        </div>
      </section>
      <section id="leadership-team">
        <Teams data={aboutData} />
      </section>
      <section id="board-committee" className="bg-red text-white3 py-16">
        <div className="max-w-5xl mx-auto px-4 text-center space-y-6">
          <div className="space-y-2">
            <p className="text-xs uppercase tracking-[0.4em] text-white/70">
              Board Committee
            </p>
            <h3 className="text-3xl md:text-4xl font-semibold">
              Governance that keeps us accountable.
            </h3>
            <p className="text-white/80 text-sm md:text-base max-w-3xl mx-auto">
              Download our Board Committee charter to understand the policies,
              oversight mechanisms, and responsibilities guiding BSS Sonata
              Microcredit.
            </p>
          </div>
          <div>
          
            <a
            href={pdfMap[file.href]}
              className="inline-flex items-center justify-center px-8 py-3 rounded-full bg-white3 text-red font-semibold text-base"
            >
              Download Committee Charter
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
